<template>
  <div class="title-wrap">
    <div class="table-wrap">
      <div class="filter">
        <el-input placeholder="请输入标题包名称" suffix-icon="el-icon-search" @change="changeKey" v-model="searchStr"> </el-input>
      </div>
      <div class="table">
        <el-table :max-height="tableHeight" ref="table" :data="tableData" style="width: 100%">
          <el-table-column prop="titlePkgName" label="标题包名称"> </el-table-column>
          <el-table-column prop="createTime" label="日期" width="180"> </el-table-column>
          <el-table-column prop="operate" label="操作" align="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewPkg(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="deletePkg(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <self-pagination
          class="footer-page"
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
    <el-dialog title="标题包详情" :visible.sync="dialogVisible" width="30%">
      <div v-if="modalDetail">
        <span>标题包名称：{{ modalDetail.name }}</span>
        <el-table :data="modalDetail.title_list" style="width: 100%" size="mini" class="modal-table">
          <el-table-column prop="title" label="标题" align="center">
            <template slot-scope="scope">
              {{ scope.row.title || "-" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryCreativeTitle, delCreativeTitle } from "@/api/promotion.js";
export default {
  data() {
    return {
      searchStr: "",
      tableHeight: window.innerHeight - 210,
      pageData: {
        total: 10,
        size: 10,
        page: 1,
      },
      tableData: [],
      dialogVisible: false,
      modalDetail: {},
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getData();
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },

  methods: {
    changePage(page) {
      this.pageData.page = page;
      this.getData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getData();
    },
    changeKey() {
      this.pageData.page = 1;
      this.getData();
    },
    getData() {
      //查询标题包
      queryCreativeTitle({
        name: this.searchStr,
        page: this.pageData.page,
        size: this.pageData.size,
      }).then((res) => {
        if (res.code === "0000") {
          this.pageData.total = res.count;
          this.tableData = res.creativeTitles;
        }
      });
    },
    refresh() {
      this.tableHeight = window.innerHeight - 210;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    deletePkg(data) {
      this.$confirm("确定删除该标题包?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCreativeTitle({ id: data.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "标题包删除成功",
                type: "success",
              });
              this.pageData.page = 1;
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    viewPkg(data) {
      this.modalDetail = JSON.parse(data.title_data);
      this.modalDetail.name = data.titlePkgName;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.title-wrap {
  padding: 16px;
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .filter {
      width: 200px;
    }
    .table {
      margin-top: 20px;
      width: 100%;
    }
  }
  .modal-table {
    margin-top: 12px;
    /deep/ .el-table__cell {
      padding: 4px;
    }
    /deep/ th {
      height: 35px;
    }
  }
}
</style>
